var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',[_c('router-view',{ref:"app-form-route-component"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }